module.exports = __webpack_public_path__ + "static/media/ic_cliente.59f3a934.svg";